import React from 'react';
import { useTranslation } from 'react-i18next';

import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { usePath } from '~/hooks';

const defaultMode = 'table';

type DisplayMode = 'table' | 'cards' | 'map';
type UseDisplayModeType = [DisplayMode, (e: RadioChangeEvent) => void];

const useDisplayMode = (defaultDisplayMode?: DisplayMode): UseDisplayModeType => {
  const { params, changePath } = usePath();
  const displayModeFromPath = params.displayMode;

  const changeMode = (e: RadioChangeEvent) => {
    const { value } = e.target;
    changePath({ displayMode: value, page: 1, perPage: usePath.defaultPageSize });
  };

  if (!displayModeFromPath) {
    changePath({ displayMode: defaultDisplayMode || defaultMode });
  }

  return [displayModeFromPath, changeMode];
};

export interface DisplayModeButtonProps {
  mode: DisplayMode;
  changeMode: (e: RadioChangeEvent) => void;
  options?: { mode: DisplayMode; disabled?: boolean }[];
}

const DisplayModeButton = (props: DisplayModeButtonProps): JSX.Element => {
  const { mode, changeMode, options = [{ mode: 'cards' }, { mode: 'table' }] } = props;
  const { t } = useTranslation();

  return (
    <Radio.Group
      options={options.map((item) => ({
        label: t(item.mode),
        value: item.mode,
        disabled: item.disabled,
      }))}
      optionType="button"
      value={mode}
      onChange={changeMode}
    />
  );
};

DisplayModeButton.useDisplayMode = useDisplayMode;

export default DisplayModeButton;
